import script from "./form.vue?vue&type=script&lang=ts&setup=true"
export * from "./form.vue?vue&type=script&lang=ts&setup=true"

import "./form.vue?vue&type=style&index=0&id=75ae6083&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75ae6083"]])

export default __exports__